export default __webpack_public_path__ + "static/media/poster.ce0934ab.jpeg";